// Circle

function Circle(options) {

  options = options || {};

  this.type = options.type || "move";

  this.x = options.x || 0;
  this.y = options.y || 0;
  this.radius = options.radius || 10;

  this.left = this.x - this.radius;
  this.top = this.y - this.radius;
  this.right = this.x + this.radius;
  this.bottom = this.y + this.radius;

  this.layer = options.layer || null;

}
